import React, { useState } from "react";
import {
    FormGroup,
    Button,
    Modal,
    Table,
    Glyphicon,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import Select from "react-select";
import { webHookDeliveryFormatOptions, webHookMethodOptions } from "./lib";
import { updateWebHook } from "../../../../../api/cp/webHook";

const WebHookEditModal = ({ locale, webHook, handleEditWebHook, eventKey }) => {
    const [headers, setHeaders] = useState(() => Object.entries(webHook.headers || {}));
    const [isSaving, setIsSaving] = useState(false);

    const handleSave = async (key, value) => {
        setIsSaving(true);

        try {
            if (key === 'headers') {
                value = Object.fromEntries(value.filter(([key]) => !!key));
            }

            handleEditWebHook(webHook.id, key, value);

            await updateWebHook(eventKey, webHook.id, {...webHook, [key]: value});
        } catch (e) {
            console.error(e);
        } finally {
            setIsSaving(false)
        }
    }

    const handleDeleteHeader = (index) => {
        const _headers = headers.filter((_, _index) => _index !== index);
        setHeaders(_headers);
        handleSave('headers', _headers);
    }

    const handleUpdateHeaderKey = (index, key) => {
        setHeaders(headers => headers.map(([_key, _value], _index) => index === _index ? [key, _value] : [_key, _value]));
    }

    const handleUpdateHeaderValue = (index, value) => {
        setHeaders(headers => headers.map(([_key, _value], _index) => index === _index ? [_key, value] : [_key, _value]));
    }

    const handleAddHeader = () => {
        setHeaders(headers => [...headers, ['', '']]);
    }

    return (
        <>
        <Modal.Header closeButton>
            <Modal.Title>{locale('settings.webHooks.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormGroup>
                <ControlLabel>Url</ControlLabel>
                <FormControl
                    type="text"
                    value={webHook.url}
                    placeholder="Url"
                    onChange={(e) => handleEditWebHook(webHook.id, 'url', e.target.value)}
                    onBlur={() => handleSave('url', webHook.url)}
                    disabled={isSaving}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{locale('settings.webHooks.method')}</ControlLabel>
                <Select
                    value={webHookMethodOptions.find(({ value }) => webHook.method === value)}
                    onChange={({ value }) => handleSave('method', value)}
                    options={webHookMethodOptions}
                    isDisabled={isSaving}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{locale('settings.webHooks.deliveryFormat')}</ControlLabel>
                <Select
                    value={webHookDeliveryFormatOptions.find(({ value }) => webHook.deliveryFormat === value)}
                    onChange={({ value }) => handleSave('deliveryFormat', value)}
                    options={webHookDeliveryFormatOptions}
                    isDisabled={isSaving}
                />
            </FormGroup>

            <FormGroup>
                <ControlLabel>{locale('settings.webHooks.headers')}</ControlLabel>

                <Table style={{ marginTop: '1rem', fontSize: '1.25rem' }}>
                    <thead>
                        <tr>
                            <th>{locale('settings.webHooks.key')}</th>
                            <th>{locale('settings.webHooks.value')}</th>
                            <th style={{width: 56}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {headers.map(([key, value], index) => (
                            <tr key={index}>
                                <td>
                                    <FormControl
                                        type="text"
                                        value={key}
                                        placeholder="Key"
                                        onChange={(e) => handleUpdateHeaderKey(index, e.target.value)}
                                        onBlur={() => handleSave('headers', headers)}
                                        disabled={isSaving}
                                    />
                                </td>
                                <td>
                                    <FormControl
                                        type="text"
                                        value={value}
                                        placeholder="Value"
                                        onChange={(e) => handleUpdateHeaderValue(index, e.target.value)}
                                        onBlur={() => handleSave('headers', headers)}
                                        disabled={isSaving}
                                    />
                                </td>
                                <td>
                                    <Button bsStyle="danger" disabled={isSaving} onClick={() => handleDeleteHeader(index)}>
                                        <Glyphicon glyph="trash"/>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <Button
                    style={{ width: "100%" }}
                    onClick={handleAddHeader}
                >
                    {locale('settings.webHooks.addHeader')}
                </Button>
            </FormGroup>
        </Modal.Body>
        </>
    );
}

export default WebHookEditModal;
